import { Dialog, DialogTitle, DialogContent, IconButton, Stack, Typography, CircularProgress } from "@mui/material";
import DescriptionIcon from '@mui/icons-material/Description';
import CloseIcon from '@mui/icons-material/Close';
import { Document } from './types';
import { useFiles } from '../../hooks/files/useFIles';
import { useEffect, useState } from 'react';

interface DocumentModalProps {
  open: boolean;
  onClose: () => void;
  document: Document | null;
}

const DocumentModal = ({ open, onClose, document }: DocumentModalProps) => {
  const { getDownloadLinks } = useFiles();
  const [documentUrl, setDocumentUrl] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchDocumentUrl = async () => {
      if (document) {
        try {
          setLoading(true);
          const links = await getDownloadLinks([document.fileId]);
          if (links.length > 0) {
            setDocumentUrl(links[0].presignedUrl);
          }
        } catch (error) {
          console.error('Error fetching document link:', error);
        } finally {
          setLoading(false);
        }
      }
    };

    if (open && document) {
      fetchDocumentUrl();
    } else {
      setDocumentUrl(null);
    }
  }, [document]);

  if (!document) return null;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xl"
      fullWidth
      sx={{
        '& .MuiDialog-paper': {
          maxWidth: '90vw',
          maxHeight: '90vh',
          width: '90vw',
          height: '90vh'
        }
      }}
    >
      <DialogTitle>
        <Stack direction="row" alignItems="center" justifyContent="space-between">
          <Stack direction="row" alignItems="center" spacing={1}>
            <DescriptionIcon />
            <Typography variant="h6">{document.screeningDocumentType}</Typography>
          </Stack>
          <IconButton onClick={onClose} size="small">
            <CloseIcon />
          </IconButton>
        </Stack>
      </DialogTitle>
      <DialogContent sx={{ p: 0, position: 'relative' }}>
        {loading ? (
          <Stack 
            direction="row" 
            justifyContent="center" 
            alignItems="center" 
            sx={{ height: 'calc(90vh - 120px)' }}
          >
            <CircularProgress />
          </Stack>
        ) : documentUrl ? (
          <iframe
            src={documentUrl}
            style={{ width: '100%', height: 'calc(90vh - 120px)', border: 'none' }}
            title={document.fileName}
          />
        ) : (
          <Stack 
            direction="row" 
            justifyContent="center" 
            alignItems="center" 
            sx={{ height: 'calc(90vh - 120px)' }}
          >
            <Typography color="error">
              Failed to load document
            </Typography>
          </Stack>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default DocumentModal; 